import { UseFormSetValue, UseFormWatch } from "react-hook-form";

import { ERROR_TYPE, translateError } from "@/utils";

import CompanySizeSelectorItem from "./CompanySizeSelectorItem";

interface CompanySizeSelectorFactoryProps {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	watch: UseFormWatch<any>;
	companySizes: { id: number; value: string }[];
	error?: string;
	containerClassName?: string;
}

export default function CompanySizeSelectorFactory({
	setValue,
	watch,
	companySizes,
	error,
	containerClassName = "",
}: CompanySizeSelectorFactoryProps) {
	const selectedCompanySizes = watch("companySizeIds");

	return (
		<div className={`space-y-1 mb-4 w-full relative ${containerClassName}`}>
			<CompanySizeSelectorItem
				companySizes={companySizes}
				error={error}
				fieldName="companySizeIds"
				setValue={setValue}
				value={selectedCompanySizes}
			/>
			{error && (
				<p className="absolute -bottom-5 text-[12px] text-[#FF1034]">
					{translateError[error as ERROR_TYPE] ?? error}
				</p>
			)}
		</div>
	);
}
